import { useState } from "react";
import { Broadcast, Channel } from "../../../../features/api/apiSlice";
import { useSocketApi } from "../../../../hooks/useSocketApi";
import PlatformIcon from "../../../PlatformIcon";
import styles from "./BroadcastDataChannel.module.css";
import cn from "classnames";

interface IBroadcastDataChannel{
  channel: Channel;
  broadcast: Broadcast;
}

const BroadcastDataChannel = ({ channel, broadcast }: IBroadcastDataChannel) => {
  const [uptimeChannel, setUptimeChannel] = useState(channel.uptime);
  useSocketApi({
    broadcastId: broadcast.id,
    channelId: channel.id,
    onUpdateChannelUptime({ uptime }) {
      setUptimeChannel(uptime);
    },
  });
  return (
    <div className={cn(styles.channel__container,
      {[styles["channel__container_disable"]]: !channel.enabled}
    )}>
      <div className={styles["channel__platform"]}>
        <PlatformIcon platform={channel.platform}/>
      </div>
      <div className={styles["channel__name-text"]}>{channel.name}</div>
      {channel.enabled &&
        <div className={styles["channel__bitrate"]}>
          <span className={styles["channel__bitrate-text"]}>{uptimeChannel} cек.</span>
        </div>
      }
    </div>
  );
};

export default BroadcastDataChannel;